<template>
  <div class="details-modal-backdrop" :class="{ 'show': show, 'is-app': $isApp }" @click="onBackdropClick">
    <div v-if="garage" class="details-modal" :class="{ 'is-app': $isApp }" @click="onModalClick">
      <div class="row">
        <b-btn primary class="map-button" @click="onGoogleMap({lat: garage.lat, lng: garage.lng})">
          {{ $translate('set-the-route', 'WYZNACZ TRASĘ') }}
        </b-btn>
        <div class="col-12 col-md-7">
          <div class="line">
            {{ garage.city }}
          </div>
          <div class="name">
            {{ garage.name }}
          </div>
        </div>
        <div class="col-12 d-md-none">
          <hr/>
        </div>
        <div v-if="$isApp">
          <div class="col-12">
            <div class="line">
              {{ getComposedStreet(garage.street_type) }} {{ garage.street }}
            </div>
            <div class="line my-3 font-weight-normal">
              {{ $translate('phone-shortcut', 'tel.') }} <a v-for="phone in garage.phones" :href="'tel:'+phone" class="notification font-weight-normal" :key="phone">
                {{phone}} </a>
            </div>
            <div class="line">
              <a :href="'mailto:'+garage.email" class="notification">{{ garage.email }}</a>
            </div>
          </div>
        </div>
        <div class="col-12 d-md-none">
          <hr/>
          <span class="font-color-light mb-3">{{ $translate('hours', 'Godziny otwarcia') }}:</span>
        </div>
        <div class="opened-wrap mt-md-0 col-12 col-md-5">
          <div class="opened">
            <span class="opened-label">{{ $translate('week-shortcut', 'Pn - Pt') }}:</span> {{ garage.opened.week || $translate('closed', 'Nieczynne') }}
          </div>
          <div class="opened">
            <span class="opened-label">{{ $translate('saturday-shortcut', 'Sob') }}:</span> {{ garage.opened.sat || $translate('closed', 'Nieczynne') }}
          </div>
          <div class="opened">
            <span class="opened-label">{{ $translate('sunday-shortcut', 'Nd') }}:</span> {{ garage.opened.sun || $translate('closed', 'Nieczynne') }}
          </div>
        </div>
      </div>
      <hr>
      <div v-if="!$isApp" class="row">
        <div class="col-12">
          <div class="line">
            {{ getComposedStreet(garage.street_type) }} {{ garage.street }}
          </div>
          <div class="line">
            {{ $translate('phone-shortcut', 'tel.') }} <a v-for="phone in garage.phones" :href="'tel:'+phone" class="notification" :key="phone">{{
            phone}} </a>
          </div>
          <div class="line">
            <a :href="'mailto:'+garage.email" class="notification">{{ garage.email }}</a>
          </div>
        </div>
      </div>
      <hr v-if="!$isApp">
      <div class="row">
        <div class="col-12">
          <div class="line light mb-3">{{ $translate('services', 'Usługi') }}:</div>
          <div class="services-wrapper">
            <Label
              v-for="(label, i) in labels"
              :key="i"
              :title="label"
            />
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-center mb-4" v-if="isMakeAnAppointment">
            <b-btn primary @click="onClick" :disabled="!garage.booking_enabled">
              UMÓW WIZYTĘ W WARSZTACIE
            </b-btn>
          </div>
          
          <p v-if="!garage.booking_enabled" class="text-center">
            {{ $translate('cant-online', 'Ten serwis nie umożliwia umawiania wizyt online.') }} <br>{{ $translate('contact-by-phone', 'Skontaktuj się telefonicznie, aby umówić wizytę') }} <br>
            <template v-for="(phone, i) in garage.phones">
              <a :href="'tel:'+phone" class="notification" :key="i">
                {{ phone }}
              </a>
              <span v-if="i + 1 < garage.phones.length" :key="i">, </span>
            </template>
          </p>
          <div class="d-flex justify-content-center">
            <a :href="getGarageUri">
              {{ $translate('go-to-workshop', 'Przejdź do strony serwisu') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBtn from '../../shared/b-btn'
import Label from './label'
import { getComposedStreet } from '../helpers/street-type-composer';

export default {
  name: 'DetailsModal',
  components: {
    BBtn, Label
  },
  data () {
    return {
      getComposedStreet: getComposedStreet.bind(this)
    }
  },
  props: {
    garage: {
      required: false,
      default: null,
      validator: (v) => typeof v === 'object'
    },
    show: {
      type: Boolean,
      required: true
    },
    isMakeAnAppointment: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    getGarageUri () {
      return `${window.garagePath}/${this.garage.slug}`
    },
    labels () {
      return this.garage.services.map((service) => {
        return service.name
      })
    }
  },
  methods: {
    onClick () {
      this.$emit('click:lead')
    },
    onBackdropClick () {
      this.$emit('update:show', false)
    },
    onModalClick (e) {
      e.stopPropagation()
    },
    onGoogleMap (e) {
      window.open(`https://www.google.pl/maps/dir//${e.lat},${e.lng}/data=!4m2!4m1!3e0`,'_blank');
    }
  }
}
</script>